// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Error } from "../flow/types";
// import type {Action} from "../flow/types";

export default function (state: Error = initialState.error, action: any) {
    switch (action.type) {
        case ActionTypes.CLEAR_ERROR:
            return initialState.error;
        case ActionTypes.LOGOUT + ActionTypes.REJECTED:
        case ActionTypes.CHECK_SESSION + ActionTypes.REJECTED:
        case ActionTypes.LOGIN + ActionTypes.REJECTED:
        case ActionTypes.REGISTER + ActionTypes.REJECTED:
        case ActionTypes.FORGOT_PASSWORD + ActionTypes.REJECTED:
        case ActionTypes.GET_FEATURED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_GROUPS + ActionTypes.REJECTED:
        case ActionTypes.GET_RECOMMENDED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_RELATED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_PRODUCT + ActionTypes.REJECTED:
        case ActionTypes.GET_ACTIVE_SETTINGS + ActionTypes.REJECTED:
        case ActionTypes.BUILD_CHECKOUT_SALE + ActionTypes.REJECTED:
        case ActionTypes.CHECK_CUSTOMER_EXISTS + ActionTypes.REJECTED:
        case ActionTypes.GET_ACTIVE_SLIDER_ITEMS + ActionTypes.REJECTED:
        case ActionTypes.GET_ORDER + ActionTypes.REJECTED:
        case ActionTypes.GET_ORDERS + ActionTypes.REJECTED:
        case ActionTypes.NEWSLETTER_SUBSCRIBE + ActionTypes.REJECTED:
        case ActionTypes.SAVE_PROFILE + ActionTypes.REJECTED:
        case ActionTypes.ORDER_CHECKOUT + ActionTypes.REJECTED:
        case ActionTypes.GENERATE_STOCK_WITH_PRICE + ActionTypes.REJECTED:
        case ActionTypes.OPENPAY_GET_STATUS + ActionTypes.REJECTED:
            if (action.payload.response.status !== 401) {
                var response = action.payload.response.data;
                return new Error(true, response.id, response.message, response.type, response.moduleCode, response.showMessageToUser, response.extraInformation ,action.type);
            }
            return state;
        default:
            return state;
    }
}
